/**
 * Created with IntelliJ IDEA.
 * User: itaik
 *
 * Date: 4/17/13
 * Time: 2:59 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    var $ = require("jquery");
    var _ = require("underscore");
    var Backbone = require("backbone");
    var BaseModel = require("models/BaseModel");
    var LEConfig = require("assets/config/le-env-conf");
    var LEResourceResolver = require("leResourceResolver");
    var Logger = require("logger");
    var $store = require("jquery.store");
    var CONST = require("const");

    // Public ENUM to control
    // The keys
    var KEY = {
        ID:"id",
        OTK:"otk",
        CURRENT_ACCOUNT_ID:"currentAccountId",
        LAST_TOUCH:"lastTouch",
        INVALIDATED:"invalidated",
        ACCOUNT_ID:"accountId",
        CONFIG:"config",
        DEFAULT_PERSONA:"defaultPersona",
        WSUK:"wsuk",
        GLOB:"glob",
        CSRF:"csrf",
        PERSONA:"persona",
        PERSONAS:"personas",
        USER_ID:"userId",
        USER_PRIVILEGES:"userPrivileges",
        LOGIN_NAME:"loginName",
        ACCOUNT_TIMEZONE_ID:"accountTimeZoneId", //deprecated key!!!
        CSDS_COLLECTION_RESPONSE:"csdsCollectionResponse",
        BASE_URIS:"baseURIs",
        LAST_STORAGE_KEY:"__last_storage_event_key",
        LAST_STORAGE_NEWVALUE:"__last_storage_event_newValue",
        LAST_STORAGE_OLDVALUE:"__last_storage_event_oldValue",
        LAST_STORAGE_TAB_CONTEXT:"__last_storage_tab_context",
        SESSION_STORAGE_TAB_CONTEXT:"__session_tab_storage_context",
        SERVER_CURRENT_TIME:"serverCurrentTime",
        SERVER_TIME_GMT_DIFF:"serverTimeGMTDiff",
        TIME_DIFF:"timeDiff",
        ACCOUNT_DATA:"accountData",
        SETTINGS_DATA:"settingsData",
        SETTINGS:"settings",
        BILLING_DATA:"billingData",
        IS_TRIAL_ACCOUNT:"isTrailAccount",
        PROVISION_DATA:"provisionData",
        REVISION:"revision",
        FEATURES:"features",
        FEATURE_ID:"compoundFeatureID",
        START_DATE:"startDate",
        END_DATE:"endDate",
        VALUE:"value",
        IS_DELETED:"isDeleted",
        CREATED_DATE:"createdDate",
        TYPE:"type",
        PROPERTY_VALUE:"propertyValue",
        DELETED:"deleted",
        SERVER_TIME_ZONE:"serverTimeZoneName",
        SSO_LOGOUT_URL:"ssoUnifiedLoginRedirectLogoutUrl",
        AGENT_GROUPS_DATA:"agentGroupsData"
    };

    var ACCOUNT_SETTINGS_ID = {
        CAPPING:       "le.campaign.capping",
        CONTROL_GROUP: "le.campaign.controlgroup",
        INACTIVE_ENGAGEMENT_STRATEGY_REDIRECT_URL: "le.campaign.offsite.campaignNotApplicable.redirectURL",
        INACTIVE_ENGAGEMENT_STRATEGY_OFFLINE_SURVEY_ID: "le.campaign.offsite.campaignNotApplicable.offlineSurveyId",
        LOCALE:        "le.general.language",
        TIME_ZONE:     "le.general.timezone",
        DEFAULT_SLA_UNITS:     "messaging.default.response.time.unit",
        MAX_CONVERSATIONS: "messaging.max.conversions",
        DEFAULT_SLA_RESPONSE_TIME: "messaging.default.response.time",
        FILE_SHARING: "messaging.file.sharing.enabled",
        AUDIO_MESSAGING: "messaging.audio.sharing.enabled",
        CURRENCY:      "le.general.currency",
        ACCOUNT_INFO: "le.site.accountInfo",
        DEFAULT_SUPPORTED_LANGUAGE:  "le.site.defaultSupportedLanguage",
        SUPPORTED_LANGUAGES:         "le.site.supportedLanguages" ,
        CANNED_RESPONSES_SOURCE:     "le.site.cannedResponses.source",
        SYSTEM_MESSAGES_SOURCE:      "le.site.autoMessages.source",
        SESSION_TIMEOUT:             "le.site.session.timeout.milliseconds",
        ROUTING_SETTINGS_SOURCE:     "le.site.routingSettings.source",
        DEFAULT_AGENT_STATUS:     "le.user.login.status",
        CONVERSIONS_WINDOW_SIZE:     "le.conversions.window.size",
        ATTRIBUTION:                 "le.general.attribution",
        CONNECTION_PANEL_VISIBILITY: "le.site.connectionPanelVisibility",
        CP_VIEW_CASE_VISIBILITY: "le.site.connectionPanelViewCaseVisibility",
        CP_OPEN_CASE_VISIBILITY: "le.site.connectionPanelOpenCaseVisibility",
        CP_NOTIFICATION_CENTER_VISIBILITY: "le.site.connectionPanelNotificationCenterVisibility",
        USERS_SOURCE:     "le.site.users.source",
        MCS_AGENT_VIEW: "mcs.agentview.indication",
        CSAT_AGENT_VIEW: "csat.agentview.indication",
        AGENT_OUTCOME: "le.agent.sdes",
        COBROWSE_CHOOSEAGENTPROFILE: "cobrowse.agent.console.chooseAgentProfile",
        COBROWSE_AGENTPROFILE: "cobrowse.agent.console.defaultSupportProfile",
        COBROWSE_AGENTRESIZE: "cobrowse.experimental.resizeAgentsScreen",
        COBROWSE_MASKEDFIELDS: "cobrowse.session.general.protectedFields",
        COBROWSE_BORDERCOLOR: "cobrowse.ui.navbar.navbar-default-bg",
        COBROWSE_HIGHLIGHTCOLOR: "cobrowse.ui.session.highlightColor",
        COBROWSE_DISABLED: "le.site.disable_cobrowse",
        AGENT_SURVEY_SUPPORT: "le.agent.survey.support",
        LOB_ENABLED: "lob.enabled",
        COAPP_ENABLED: "coapp.enabled",
        COAPP_SETTINGS: "coapp.settings",
        HIDE_IS_TRIAL: "hide.isTrial",
        DISABLED_NON_RESPONSE_STATE: "messaging.connection.nonresponsivestate.disabled",
        NON_RESPONSE_NOTIFY_TIME:"messaging.connection.notify.time",
        LE_UI_CUSTOMIZATION: "le.ui.customization",
        WEBAGENT_DISABLE_ICONS_FOR_MESSAGING: 'le.agent.chatInput.disableIconsForMessaging',
        WEBAGENT_DISABLE_ICONS_FOR_REALTIME: 'le.agent.chatInput.disableIconsForRealTimeChat',
        AGENT_ALERT_ON_PASTE:'le.agent.alertOnPaste',
        CHAT_FALLBACK_ENABLED: "cp.chat.fallback.enabled",
        REPORTING_MAX_MONTH_TIMEFRAME_AVAILABLE_HISTORY: "le.reporting.max.month.timeframe.available.history",
        SHIFT_STATUS_MANUAL: "messaging.manual.shifts.management",
        MESSAGING_FILE_SHARING_ENABLED: "messaging.file.sharing.enabled"
    };

    var COMPOUND_FEATURE_ID = {
        REPORTS_LE_MSTR_ACCESS:"Reports.leMstrAccess",
        LP_INSIGHTS_MR_PROCESS_EXECUTION:"LPInsights.MRProcessExecution",
        COMMON_LIVE_ENGAGE_2:"Common.LiveEngage_2",
        COMMON_ETL_HADOOP:"Common.ETLHadoop",
        COMMON_BILLING_CPI2:"Common.Billing_CPI2",
        COMMON_LIVE_ENGAGE_2_MIGRATING:"Common.LiveEngage_2_Migrating",
        COMMON_BLOCK_ADDING_USERS:"Common.BlockAddingUsers",
        COMMON_BLOCK_SUPPORT_ACCESS:"Common.BlockSupportAccess",
        COMMON_BLOCK_MSTR: "Common.Block_MSTR",
        COMMON_APIKEY_MANAGEMENT: "Common.Api_key_management",
        COMMON_IP_RESTRICTION: "Common.IP_Restriction",
        COMMON_AI_ASSIST_WIDGET: "Common.AI_Assist_Widget",
        LE_UI_MYACCOUNT: "LEUI.MyAccount",
        LE_UI_CONNECTION_BAR_DISPLAY:"LEUI.ConnectionBar_Display",
        LE_UI_CONNECTION_BAR_CASE_MANAGEMENT_VISIBLE: "LEUI.ConnectionBar_CaseManagement_Visible",
        LE_UI_CONNECTION_BAR_OPEN_CASE_VISIBLE: "LEUI.ConnectionBar_OpenCase_Visible",
        LE_UI_CONNECTION_BAR_NOTIFICATION_VISIBLE: "LEUI.ConnectionBar_Notification_Visible",
        LE_UI_WEB_ANALYTICS:"LEUI.WebAnalytics",
        REPORTS_LE_DASHBOARD_ACCESS:"Reports.leDashboardAccess",
        SHARK_COMPARISON_GROUP_TAGLETS:"Shark.ComparisonGroupTaglets",
        DATA_ENCRYPTION:"legacy.69", // because this came from the AppServer, they return it like ths way: 'legacy.69' :-(
        UNIFIED_WINDOW:"Common.LiveEngage_2_Unified_window",
        STICKY_SIZE_LIMIT:"Common.LiveEngage_2_Limit_Sticky_Size",
        OFFSITE_ENGAGEMENT:"Common.LiveEngage_2_Offsite_Engagement",
        HOT_TOPICS: "Analytics.LiveEngage_2_HotTopics",
        USER_MANAGEMENT_AC_USERS: "Common.User_Management_AC_Users",
        AGENT_GROUPS: "Common.AgentGroups",
        VISITOR_FEED_PREFILTERING: "Common.VisitorFeed.PreFiltering",
        ASYNC_MESSAGING: "Common.Async_Messaging",
        WRAP_UP_TIME: "Chat.Wrap_Up",
        CONVERSATION_SOURCES: "Common.Messaging_Conversation_Sources",
        MESSAGING_AUTO_MESSAGES: "Messaging.Auto_Messages",
        MESSAGING_EDIT_AUTO_MESSAGES: "Messaging.Edit_Auto_Messages",
        MESSAGING_UNAUTH_MESSAGING: "Messaging.Un_Auth_Messaging",
        MESSAGING_AUTO_CLOSE_PER_SKILL: "Messaging.AutoClosePerSkill",
        MESSAGING_TRANSFER_TO_AGENT: "Messaging.Transfer_To_Agent",
        GOOGLE_SOURCE: "Common.Messaging_Conversation_Sources_Google",
        LIVEPERSON_AUTHENTICATION_METHOD: "Common.LivePerson_Authentication_Method",
        AUTHENTICATED_CHAT: "Common.Authenticated_Chat",
        MULTI_CHAT_LOAD_BALANCING: "Common.LiveEngage_2_MultipleChatCenterLoadBalancing",
        COBROWSE_INTEGRATION: "Cobrowse.Cobrowse_Integration",
        MULTI_CHAT_CASCADING_LOAD_BALANCING: "Common.LiveEngage_2_ChatCenterLoadBalancing_Cascading",
        REPORT_BUILDER_ACCESS: "Reports.leReportBuilderAccess",
        REPORT_BUILDER_NON_LPA_ACCESS: "Reports.leReportBuilderNonLpa",
        LOB_SUPPORT: "Common.LiveEngage_LOB_Support",
        ENTITIES_TAGGING_BY_LOB: "LEUI.Tagging_By_LOB",
        PROFILES_FEATURE: "Common.Profiles",
        LPA_PROFILES_ASSIGNMENT_FEATURE: "Common.LPA_Profiles_Assignment",
        AUDIT_TRAIL_FEATURE: "Common.AuditTrail",
        REFRESH_BUTTON: "Common.RefreshButton",
        USER_TYPE_BOT: "Common.User_type_bot",
        MULTIPLE_AGENT_STATES: "Common.Multiple_Agent_Status",
        SLA_PER_SKILL: "Common.SLAPerSkill",
        LIVE_CHAT_QUEUE_PRIORITY:"Common.LiveChat_Queue_Priority",
        AUTOMATION_AREA: "Automation.Automation_Area",
        CONTENT_PROVIDER_ACCOUNT_FEATURE: "Common.ContentProviderAccount",
        MESSAGING_SURVEY:"Common.Messaging_Survey"

    };

    var CONFIG_ATTRIBUTE_ID = {
        LPA: "isLPA",
        ADMIN: "isAdmin"
    };

    var PERSONA = CONST.PERSONA;
    var PRIVILEGE_TO_PERSONA_MAP = CONST.PRIVILEGE_TO_PERSONA_MAP;
    var DEFAULT_PERSONA_PRIORITY_MAP = CONST.DEFAULT_PERSONA_PRIORITY_MAP;

    // Define the default values for the model
    var defaults = {};
    defaults[KEY.ID] = void 0;
    defaults[KEY.OTK] = void 0;
    defaults[KEY.ACCOUNT_ID] = void 0;
    defaults[KEY.CONFIG] = {};
    defaults[KEY.CONFIG][KEY.DEFAULT_PERSONA] = PERSONA.GUEST;
    defaults[KEY.WSUK] = void 0;
    defaults[KEY.GLOB] = void 0;
    defaults[KEY.CSRF] = void 0;
    defaults[KEY.PERSONA] = void 0;
    defaults[KEY.PERSONAS] = void 0;

    var SessionModel = BaseModel.extend({
        // Expose enums also on the model instance level
        KEY:KEY,
        ACCOUNT_SETTINGS_ID:ACCOUNT_SETTINGS_ID,
        COMPOUND_FEATURE_ID:COMPOUND_FEATURE_ID,
        PERSONA:PERSONA,
        PRIVILEGE_TO_PERSONA_MAP:PRIVILEGE_TO_PERSONA_MAP,
        DEFAULT_PERSONA_PRIORITY_MAP:DEFAULT_PERSONA_PRIORITY_MAP,

        idAttribute:KEY.ID,
        apiResourceConfig:LEResourceResolver.apiResources.AccountConfig.Session.RealTime,
        untouched:true,
        hasLiveEngage2:false,
        hasDataEncryptionFeature:false,
        hasMessagingFeature:false,
        hasSLAPerSkill:false,
        hasWrapUpFeature:false,
        hasLpAuthenticationFeature:false,
        isMigrating:false,
        unifiedWindow:false,
        limitStickySize: false,
        offsiteEngagement: false,
        isBlockAddingUsersFeature: false,
        isBlockSupportAccessFeature: false,
        isSeatBasedFeature: false,
        authenticationChat:false,
        blockMSTR: false,
        apiKeyManagement: false,
        enableLEMyAccount: false,
        multiChatCenterLoadBalancing: false,
        multiChatCenterCascadingLoadBalancing: false,
        lobFeature: false,
        name: "SessionModel",

        prepareResource:function (otk) {
            this.apiResourceConfig = LEResourceResolver.apiResources.AccountConfig.Session.RealTime;
        },

        url:function () {
            // Never add ID to the URL
            var hide = this.get(this.idAttribute);

            if (hide) {
                this.unset(this.idAttribute, { silent: true });
                var url = BaseModel.prototype.url.call(this);
                this.set(this.idAttribute, hide, { silent: true });

                return url;
            }
            else {
                return BaseModel.prototype.url.call(this);
            }
        },

        isNullOrEmptyString:function (string) {
            return (!_.isString(string) || 0 === string.length);
        },

        isNewSession:function (creds) {
            creds = creds || {};

            if (!this.isNullOrEmptyString(creds[KEY.OTK])) {
                return true;
            }

            if (!this.isNullOrEmptyString(creds[KEY.ACCOUNT_ID])) {
                this.load({ accountId:creds[KEY.ACCOUNT_ID] });
                this.set(KEY.ACCOUNT_ID, creds[KEY.ACCOUNT_ID], { silent:true });
            }

            return (this.isNullOrEmptyString(this.get(KEY.CSRF)));
        },

        hasAttributeValue:function (key) {
            return !this.isNullOrEmptyString(this.get(key));
        },

        validate:function (attrs) {
            var errors = [];

            if (this.isNullOrEmptyString(attrs[KEY.ACCOUNT_ID])) {
                this.logger.error("Invalid accountId Parameter");
                this.logger.graph({name:"framework:sessionModel:validate:invalidAccountId"});

                errors.push({ name:"Login Parameters", message:"Invalid accountId Parameter" });
            } else {
                this.load({ accountId:attrs[KEY.ACCOUNT_ID] });
            }

            if (this.isNullOrEmptyString(attrs[KEY.OTK])) {
                if (this.isNullOrEmptyString(attrs[KEY.CSRF]) && this.isNullOrEmptyString(this.get(KEY.CSRF))) {
                    this.logger.error("Could not find no OTK and no CSRF token - NO CAN BE!!!");
                    this.logger.graph({name:"framework:sessionModel:validate:noOtkNoCSRF"});

                    errors.push({ name:"Login Parameters", message:"Invalid OTK and CSRF" });
                }
            }

            if (0 < errors.length) {
                return errors;
            }

            this.prepareResource.call(this, attrs[KEY.OTK]);

            return false;
        },

        resource:function () {
            return LEResourceResolver.extendResourceWithOptions.call(this, this.apiResourceConfig, { accountId:this.get(KEY.ACCOUNT_ID) });
        },

        defaults:defaults,

        initialize:function (options) {
            // Just call the method of the initialize logic
            this.logger = Logger.getLogger("LEFramework");
            this.load(options);
        },

        loadJSON:function (data) {
            return data && JSON.parse(data) || void 0;
        },

        loadValue:function (options) {
            options = options || {};

            if (KEY.CURRENT_ACCOUNT_ID === options.key) {
                return this.loadJSON($.localStorage(KEY.CURRENT_ACCOUNT_ID));
            }

            if (this.isNullOrEmptyString(options.accountId)) {
                options.accountId = this.get(KEY.ACCOUNT_ID);
                options.setAccountIdOptions = void 0;
            }

            if (this.isNullOrEmptyString(options.accountId)) {
                return void 0;
            } else {
                var jsonObject = this.loadJSON($.localStorage(options.accountId + "_" + options.key));

                if (!_.isUndefined(options.applyOptions) && !_.isUndefined(jsonObject)) {
                    this.set(options.key, jsonObject, options.applyOptions);
                }

                return jsonObject;
            }
        },

        getStored:function (key) {
            return this.loadValue({ key:key });
        },

        hasValidValue:function (key, options) {
            var val = this.get(key);

            if (options && options.stored) {
                var stored = this.getStored.call(this, key);
                return !this.isNullOrEmptyString(val) && !this.isNullOrEmptyString(stored);
            } else {
                return !this.isNullOrEmptyString(val);
            }
        },

        setLocalStorageFixIE8MissingValues:function (key, value) {
            // IE8 fix missing storageEvent.key
            if ("onstorage" in document) {
                var oldValue = this.loadJSON($.localStorage(key));
                var dateNow = new Date();
                var options = {
                    expires:dateNow.setSeconds(dateNow.getSeconds() + 30)
                };

                // I'll set it in cookie and localstorage since IE8 acts weird and sometimes local storage does not updates
                $.cookie(KEY.LAST_STORAGE_KEY, JSON.stringify(key), options);
                $.cookie(KEY.LAST_STORAGE_NEWVALUE, value, options);
                $.cookie(KEY.LAST_STORAGE_OLDVALUE, JSON.stringify(oldValue), options);

                $.localStorage(KEY.LAST_STORAGE_KEY, JSON.stringify(key));
                $.localStorage(KEY.LAST_STORAGE_NEWVALUE, value);
                $.localStorage(KEY.LAST_STORAGE_OLDVALUE, JSON.stringify(oldValue));
            }
        },

        cleanLocalStorageFixIE8MissingValues:function () {
            // IE8 fix missing storageEvent.key
            if ("onstorage" in document) {
                $.removeCookie(KEY.LAST_STORAGE_KEY);
                $.removeCookie(KEY.LAST_STORAGE_NEWVALUE);
                $.removeCookie(KEY.LAST_STORAGE_OLDVALUE);

                $.localStorage().removeItem(KEY.LAST_STORAGE_KEY);
                $.localStorage().removeItem(KEY.LAST_STORAGE_NEWVALUE);
                $.localStorage().removeItem(KEY.LAST_STORAGE_OLDVALUE);
            }
        },

        getLocalStorageFixIE8MissingValue:function (key) {
            var val = $.localStorage(key);

            val = !this.isNullOrEmptyString(val) ? this.loadJSON(val) : void 0;

            if (!val) {
                val = $.cookie(key);

                val = !this.isNullOrEmptyString(val) ? this.loadJSON(val) : void 0;
            }

            return val;
        },

        getLocalStorageFixIE8MissingValues:function (options) {
            var values;

            options = options || {};

            // IE8 fix missing storageEvent.key
            if ("onstorage" in document) {
                var key = this.getLocalStorageFixIE8MissingValue(KEY.LAST_STORAGE_KEY);
                var newValue = this.getLocalStorageFixIE8MissingValue(KEY.LAST_STORAGE_NEWVALUE);
                var oldValue = this.getLocalStorageFixIE8MissingValue(KEY.LAST_STORAGE_OLDVALUE);

                values = {
                    key:key,
                    value:newValue,
                    oldValue:oldValue
                };

                if (options.clean) {
                    this.cleanLocalStorageFixIE8MissingValues();
                }
            }

            return values;
        },

        localStorageStoreItem:function (key, jsonString) {
            if (KEY.CURRENT_ACCOUNT_ID === key) {
                this.setLocalStorageFixIE8MissingValues(key, jsonString);
            }

            // For hacking multitab support
            // TODO: Remove when MultiTab support should be enabled
            if (KEY.CURRENT_ACCOUNT_ID === key) {
                // event is not sent if the storage is not mutated!
                if (null !== $.localStorage("rand")) {
                    this.localStorageClearItem("rand");
                }

                $.localStorage(KEY.LAST_STORAGE_TAB_CONTEXT, JSON.stringify(this.getSessionContext()));
            }

            $.localStorage(key, jsonString);

//            if (KEY.CURRENT_ACCOUNT_ID === key) {
//                this.cleanLocalStorageFixIE8MissingValues();
//            }
        },

        sessionStorageStoreItem:function (key, jsonString) {
            $.sessionStorage(key, jsonString);
        },

        localStorageClearItem:function (key) {
            if (KEY.CURRENT_ACCOUNT_ID === key) {
                this.setLocalStorageFixIE8MissingValues(key, null);
            }

            $.localStorage().removeItem(key);

//            if (KEY.CURRENT_ACCOUNT_ID === key) {
//                this.cleanLocalStorageFixIE8MissingValues();
//            }
        },

        sessionStorageClearItem:function (key) {
            $.sessionStorage().removeItem(key);
        },

        getCurrentAccountIds:function () {
            var current = this.loadValue({ key:KEY.CURRENT_ACCOUNT_ID });

            if (this.isNullOrEmptyString(current)) {
                return [];
            } else {
                return current.split("!");
            }
        },

        getCurrentAccountId:function () {
            var ids = this.getCurrentAccountIds();

            // Get the last account ID in the list of active accounts
            if (!ids || 0 === ids.length) {
                return void 0;
            } else {
                var pointer = ids.length - 1;
                var id = ids[pointer];

                while (this.isNullOrEmptyString(id) && 0 <= --pointer) {
                    id = ids[pointer];
                }

                return (!this.isNullOrEmptyString(id) ? id : void 0);
            }
        },

        setCurrentAccountId:function (accountId) {
            if (!this.isNullOrEmptyString(accountId)) {
                var current = this.loadValue({ key:KEY.CURRENT_ACCOUNT_ID });

                if (this.isNullOrEmptyString(current)) {
                    current = accountId;
                } else {
                    current = this.removeAccountIdFromCurrent(accountId);

                    if (_.isString(current)) {
                        current += "!";
                    } else {
                        current = "";
                    }
                    current += accountId;
                }

                this.localStorageStoreItem(KEY.CURRENT_ACCOUNT_ID, JSON.stringify(current));
            }
        },

        removeAccountIdFromCurrent:function (accountId) {
            var current = this.loadValue({ key:KEY.CURRENT_ACCOUNT_ID });

            if (!this.isNullOrEmptyString(accountId)) {
                if (!this.isNullOrEmptyString(current)) {
                    var ids = current.split("!");
                    var ind = _.indexOf(ids, accountId);
                    if (-1 !== ind) {
                        ids.splice(ind, 1);

                        if (0 < ids.length) {
                            current = ids.join("!");
                            this.localStorageStoreItem(KEY.CURRENT_ACCOUNT_ID, JSON.stringify(current));
                        } else {
                            current = void 0;
                            this.localStorageClearItem(KEY.CURRENT_ACCOUNT_ID);
                        }
                    }
                }
            }

            return current;
        },

        hasCurrentAccountId:function (options) {
            options = options || {};
            var accountIdFound = false;

            var accountId = options.accountId || this.get(KEY.ACCOUNT_ID);

            if (!this.isNullOrEmptyString(accountId)) {
                var current = options.current || this.loadValue({ key:KEY.CURRENT_ACCOUNT_ID });

                if (!this.isNullOrEmptyString(current)) {
                    var ids = current.split("!");
                    var ind = _.indexOf(ids, accountId);

                    accountIdFound = (-1 !== ind);
                }
            }

            return accountIdFound;
        },

        invalidateAccountSession:function (accountId) {
            this.storeValue({ key:KEY.INVALIDATED, value:true, accountId:accountId });
        },

        isInvalidatedSession:function () {
            var invalidated = this.getStored(KEY.INVALIDATED);

            if ("true" === invalidated) {
                invalidated = true;
            }

            return invalidated || false;
        },

        isValidSession:function () {
            var valid = this.hasValidValue(KEY.ID) &&
                this.hasValidValue(KEY.ACCOUNT_ID) &&
                this.hasValidValue(KEY.CSRF) &&
                this.hasValidValue(KEY.GLOB) &&
                this.hasValidValue(KEY.WSUK);

            return valid && !this.isInvalidatedSession() && !this.isNew();
        },

        storeValue:function (options) {
            options = options || {};

            if (!this.isNullOrEmptyString(options.key)) {
                if (_.isUndefined(options.value)) {
                    options.value = this.get(options.key);
                    options.setValueOptions = void 0;
                }

                if (!_.isUndefined(options.value)) {
                    var jsonString = JSON.stringify(options.value);
                    if (!_.isUndefined(options.setValueOptions)) {
                        this.set(options.key, options.value, options.setValueOptions);
                    }
                    if (KEY.ACCOUNT_ID === options.key) {
                        this.setCurrentAccountId(options.value);
                    } else {
                        if (!this.isNullOrEmptyString(options.accountId) && !_.isUndefined(options.setAccountIdOptions)) {
                            this.set(KEY.ACCOUNT_ID, options.accountId, { silent:true });
                            this.setCurrentAccountId(options.accountId);
                        }
                        options.accountId = options.accountId || this.get(KEY.ACCOUNT_ID);

                        var key = options.accountId + "_" + options.key;
                        this.localStorageStoreItem(key, jsonString);
                    }
                }
            }
        },

        updateLastTouched:function () {
            this.storeValue({ key:KEY.LAST_TOUCH, value:(new Date()).getTime() });
        },

        getLastTouched:function () {
            var last = this.getStored(KEY.LAST_TOUCH);

            return _.isNumber(last) ? last : (!isNaN(last) ? parseInt(last, 10) : 0);
        },

        randomizeContext:function (placeholder) {
            return placeholder ? (placeholder ^ Math.random() * 16 >> placeholder / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, this.randomizeContext);
        },

        getSessionContext:function () {
            var context = this.loadJSON($.sessionStorage(KEY.SESSION_STORAGE_TAB_CONTEXT + "_LE2"));

            if (this.isNullOrEmptyString(context)) {
                context = this.randomizeContext();
                this.sessionStorageStoreItem(KEY.SESSION_STORAGE_TAB_CONTEXT + "_LE2", JSON.stringify(context));
            }

            return context;
        },

        isLastUpdateOwner:function () {
            return this.getSessionContext() === this.loadJSON($.localStorage(KEY.LAST_STORAGE_TAB_CONTEXT));
        },

        load:function (options) {
            // TODO: implement the load (to localStorage or cookies)
            // For now I just use jquery localStorage plugin with cookies fallback
            options = options || {};

            var context = this.getSessionContext();
            var accountId = options.accountId || this.get(KEY.ACCOUNT_ID); // || this.getCurrentAccountId();
            if (!this.isNullOrEmptyString(accountId)) {
                this.loadValue({ key:KEY.CSRF, accountId:accountId, setAccountIdOptions:{ silent:true }, applyOptions:{ silent:true }});
                this.loadValue({ key:KEY.PERSONA, accountId:accountId, setAccountIdOptions:{ silent:true }, applyOptions:{ silent:true }});
            }
        },

        parse:function (response) {
            if (!_.isUndefined(response) && !_.isString(response)) {

                // For hacking multitab support
                // TODO: Remove when MultiTab support should be enabled
                // Validate there is no previous user on this session
                var previousUser = this.loadJSON($.sessionStorage(KEY.USER_ID + "_LE2"));
                var accountId = this.get(KEY.ACCOUNT_ID);
                var loginName = response[KEY.CONFIG][KEY.LOGIN_NAME];

                if (!this.isNullOrEmptyString(previousUser) && previousUser !== (accountId + ">>" + loginName)) {
                    var prevAccountId = previousUser.split(">>")[0];

//                    if (prevAccountId === accountId) {
//                        this.logger.debug("Holy Sh!!!!!!!!t, a different user is now using this tab - This can cause a Zombie session to be left active!");
//                        this.logger.debug("Lets destroy the previous user session (I must use a synchronous call here)!");
//                        this.set(KEY.ID, "destroy");
//                        this.set(KEY.ACCOUNT_ID, prevAccountId);
//                        this.destroy({ async:false });
//                        this.set(KEY.ACCOUNT_ID, accountId);
//                        this.unset(KEY.ID);
//                    } else {
//                        this.logger.debug("The previous user session is of different account, no way to destroy it from the client!");
//                    }
                    this.logger.debug("Holy Sh!!!!!!!!t, a different user is now using this tab - This can cause a Zombie session to be left active!");
                    this.logger.debug("Lets clean zombies from storage!");
                    this.flushStore({ accountId: prevAccountId, flushStore: { local: true, session: true } });
                }

                var persona = this.get(KEY.PERSONA);

                // parse the privileges and assemble the valid personas array for this user
                response[KEY.CONFIG][KEY.PERSONAS] = [];
                response[KEY.CONFIG][KEY.USER_PRIVILEGES] = response[KEY.CONFIG][KEY.USER_PRIVILEGES] || [];

                // Add the configured default privileges if any
                // We are using a mechanism of default privileges
                // Which can be pre-configured and added to the
                // list of privileges returned from the session creation
                // This is used for the web-agent beta for example
                // We add the web-agent privilege as a pre-configured
                // Default privilege to all loggged in users just to
                // Support old sites that were not created with the
                // Needed privileges
                var defaultPrivileges = LEConfig.defaultPrivileges;
                if (_.isArray(defaultPrivileges)) {
                    _.each(defaultPrivileges, function (privilege, index) {
                        if (!_.contains(response[KEY.CONFIG][KEY.USER_PRIVILEGES], privilege)) {
                            response[KEY.CONFIG][KEY.USER_PRIVILEGES].push(privilege);
                        }
                    });
                }

                this.lobFeature = this. _findFeature(response, COMPOUND_FEATURE_ID.LOB_SUPPORT);
                this.entitiesTaggingByLob = this. _findFeature(response, COMPOUND_FEATURE_ID.ENTITIES_TAGGING_BY_LOB);
                this.multiChatCenterLoadBalancing = this. _findFeature(response, COMPOUND_FEATURE_ID.MULTI_CHAT_LOAD_BALANCING);
                this.hasCoBrowseFeauture = this. _findFeature(response, COMPOUND_FEATURE_ID.COBROWSE_INTEGRATION);
                this.multiChatCenterCascadingLoadBalancing = this. _findFeature(response, COMPOUND_FEATURE_ID.MULTI_CHAT_CASCADING_LOAD_BALANCING);
                this.hasLiveEngage2 = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_LIVE_ENGAGE_2);
                this.hasDataEncryptionFeature = this._findFeature(response, COMPOUND_FEATURE_ID.DATA_ENCRYPTION);
                this.hasMessagingFeature = this._findFeature(response, COMPOUND_FEATURE_ID.ASYNC_MESSAGING);
                this.hasSLAPerSkill = this._findFeature(response, COMPOUND_FEATURE_ID.SLA_PER_SKILL);
                this.hasWrapUpFeature = this._findFeature(response, COMPOUND_FEATURE_ID.WRAP_UP_TIME);
                this.hasUserTypeBot = this._findFeature(response, COMPOUND_FEATURE_ID.USER_TYPE_BOT);
                this.hasConversationSources = this._findFeature(response, COMPOUND_FEATURE_ID.CONVERSATION_SOURCES);
                this.hasMessagingAutoMessages = this._findFeature(response, COMPOUND_FEATURE_ID.MESSAGING_AUTO_MESSAGES);
                this.hasEditMessagingAutoMessages = this._findFeature(response, COMPOUND_FEATURE_ID.MESSAGING_EDIT_AUTO_MESSAGES);
                this.hasUnauthMessaging = this._findFeature(response, COMPOUND_FEATURE_ID.MESSAGING_UNAUTH_MESSAGING);
                this.hasAutoClosePerSkill = this._findFeature(response, COMPOUND_FEATURE_ID.MESSAGING_AUTO_CLOSE_PER_SKILL);
                this.hasMessagingTransferToAgent = this._findFeature(response, COMPOUND_FEATURE_ID.MESSAGING_TRANSFER_TO_AGENT);
                this.hasGoogleSource = this._findFeature(response, COMPOUND_FEATURE_ID.GOOGLE_SOURCE);
                this.hasLpAuthenticationFeature = this._findFeature(response, COMPOUND_FEATURE_ID.LIVEPERSON_AUTHENTICATION_METHOD);
                this.isMigrating = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_LIVE_ENGAGE_2_MIGRATING);
                this.isAgentGroups = this._findFeature(response, COMPOUND_FEATURE_ID.AGENT_GROUPS);
                this.isVisitorFeedPreFiltering = this._findFeature(response, COMPOUND_FEATURE_ID.VISITOR_FEED_PREFILTERING);
                this.unifiedWindow = this._findFeature(response, COMPOUND_FEATURE_ID.UNIFIED_WINDOW);
                this.limitStickySize = this._findFeature(response, COMPOUND_FEATURE_ID.STICKY_SIZE_LIMIT);
                this.offsiteEngagement = this._findFeature(response, COMPOUND_FEATURE_ID.OFFSITE_ENGAGEMENT);
                this.hotTopicsFeature = this._findFeature(response, COMPOUND_FEATURE_ID.HOT_TOPICS);
                this.lpa = this._findConfig(response, CONFIG_ATTRIBUTE_ID.LPA);
                this.admin = this._findConfig(response, CONFIG_ATTRIBUTE_ID.ADMIN);
                this.authenticationChat = this._findFeature(response, COMPOUND_FEATURE_ID.AUTHENTICATED_CHAT);
                this.isBlockAddingUsersFeature = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_BLOCK_ADDING_USERS);
                this.isBlockSupportAccessFeature = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_BLOCK_SUPPORT_ACCESS);
                this.isSeatBasedFeature = this.hasLiveEngage2 && !this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_BILLING_CPI2);
                this.blockMSTR = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_BLOCK_MSTR);
                this.apiKeyManagement = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_APIKEY_MANAGEMENT);
                this.ipRestriction = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_IP_RESTRICTION);
                this.aiAssistWidgetFeature = this._findFeature(response, COMPOUND_FEATURE_ID.COMMON_AI_ASSIST_WIDGET);
                this.enableLEMyAccount= this._findFeature(response, COMPOUND_FEATURE_ID.LE_UI_MYACCOUNT);
                this.reportBuilderAccessFeature = this._findFeature(response, COMPOUND_FEATURE_ID.REPORT_BUILDER_ACCESS);
                this.reportBuilderNonLpaAccessFeature = this._findFeature(response, COMPOUND_FEATURE_ID.REPORT_BUILDER_NON_LPA_ACCESS);
                this.profilesFeature = this._findFeature(response, COMPOUND_FEATURE_ID.PROFILES_FEATURE);
                this.connectionBarCaseManagementVisible = this._findFeature(response, COMPOUND_FEATURE_ID.LE_UI_CONNECTION_BAR_CASE_MANAGEMENT_VISIBLE);
                this.connectionBarDisplay = this._findFeature(response, COMPOUND_FEATURE_ID.LE_UI_CONNECTION_BAR_DISPLAY);
                this.connectionBarOpenCaseVisible = this._findFeature(response, COMPOUND_FEATURE_ID.LE_UI_CONNECTION_BAR_OPEN_CASE_VISIBLE);
                this.connectionBarNotificationVisible = this._findFeature(response, COMPOUND_FEATURE_ID.LE_UI_CONNECTION_BAR_NOTIFICATION_VISIBLE);
                this.lpaProfilesAssignmentFeature = this._findFeature(response, COMPOUND_FEATURE_ID.LPA_PROFILES_ASSIGNMENT_FEATURE);
                this.auditTrailFeature = this._findFeature(response, COMPOUND_FEATURE_ID.AUDIT_TRAIL_FEATURE);
                this.multipleAgentStatesFeature = this._findFeature(response, COMPOUND_FEATURE_ID.MULTIPLE_AGENT_STATES);
                this.refreshButtonFeature = this._findFeature(response, COMPOUND_FEATURE_ID.REFRESH_BUTTON);
                this.liveChatQueuePriority = this._findFeature(response, COMPOUND_FEATURE_ID.LIVE_CHAT_QUEUE_PRIORITY);
                this.automationAreaFeature = this._findFeature(response, COMPOUND_FEATURE_ID.AUTOMATION_AREA);
                this.contentProviderAccountFeature = this._findFeature(response, COMPOUND_FEATURE_ID.CONTENT_PROVIDER_ACCOUNT_FEATURE);
                this.messagingSurveyFeature = this._findFeature(response, COMPOUND_FEATURE_ID.MESSAGING_SURVEY);

                this.logger.debug("multiChatCenterLoadBalancing = " + this.multiChatCenterLoadBalancing);
                this.logger.debug("multiChatCenterCascadingLoadBalancing = " + this.multiChatCenterCascadingLoadBalancing);
                this.logger.debug("hasLiveEngage = " + this.hasLiveEngage2);
                this.logger.debug("hasDataEncryptionFeature = " + this.hasDataEncryptionFeature);
                this.logger.debug("hasMessagingFeature = " + this.hasMessagingFeature);
                this.logger.debug("hasWrapUpTimeFeature = " + this.hasWrapUpFeature);
                this.logger.debug("hasUserTypeBot = " + this.hasUserTypeBot);
                this.logger.debug("hasLpAuthenticationFeature = " + this.hasLpAuthenticationFeature);
                this.logger.debug("isMigrating = " + this.isMigrating);
                this.logger.debug("isAgentGroups = " + this.isAgentGroups);
                this.logger.debug("isVisitorFeedPreFiltering = " + this.isVisitorFeedPreFiltering);
                this.logger.debug("limitStickySize = " + this.limitStickySize);
                this.logger.debug("offsiteEngagement = " + this.offsiteEngagement);
                this.logger.debug("hasBlockAddingUsersFeature = " + this.isBlockAddingUsersFeature);
                this.logger.debug("hasBlockSupportAccessFeature= " + this.isBlockSupportAccessFeature);
                this.logger.debug("hasSeatBasedFeature= " + this.isSeatBasedFeature);
                this.logger.debug("authenticationChat = " + this.authenticationChat);
                this.logger.debug("blockMSTR = " + this.blockMSTR);
                this.logger.debug("apiKeyManagement = " + this.apiKeyManagement);
                this.logger.debug("ipRestriction = "+ this.ipRestriction);
                this.logger.debug("enableLEMyAccount = " + this.enableLEMyAccount);
                this.logger.debug("lobFeature = " + this.lobFeature);
                this.logger.debug("entitiesTaggingByLob = " + this.entitiesTaggingByLob);
                this.logger.debug("hasAutomationAreaFeature = " + this.hasAutomationAreaFeature);

                this.logger.debug("connectionBarCaseManagementVisible = " + this.connectionBarCaseManagementVisible);
                this.logger.debug("connectionBarDisplay = " + this.connectionBarDisplay);
                this.logger.debug("connectionBarOpenCaseVisible = " + this.connectionBarOpenCaseVisible);
                this.logger.debug("connectionBarNotificationVisible = " + this.connectionBarNotificationVisible);

                this.logger.debug("reportBuilderAccessFeature = " + this.reportBuilderAccessFeature);
                this.logger.debug("reportBuilderNonLpaAccessFeature = " + this.reportBuilderNonLpaAccessFeature);
                this.logger.debug("lpaProfilesAssignmentFeature = " + this.lpaProfilesAssignmentFeature);
                this.logger.debug("contentProviderAccountFeature = " + this.contentProviderAccountFeature);
                this.logger.debug("liveChatQueuePriority = " + this.liveChatQueuePriority);
                this.logger.debug("messagingSurveyFeature = " + this.messagingSurveyFeature);
                this.logger.debug("aiAssistWidgetFeature = " + this.aiAssistWidgetFeature);

                if (this.hasLiveEngage2 || this.isMigrating) {
                    // Iterate over all available personas
                    _.each(PRIVILEGE_TO_PERSONA_MAP, function (value, key) {
                        // Check if the privileges list contains the current persona and
                        // that the account is not migrating and the current persona is admin
                        // Account will be defined as migrating only if it has the migrating feature
                        // and not the LE2 feature. For migrating accounts, the user management (admin persona)
                        // should not be available

                        this._compareUserPrivligesForPersona(value, key, response);  //value can be either a number or array of nunbers

                    }, this);
                } else {
                    // Check if the privileges list contains the agent persona
                    var agentPrivilege = PRIVILEGE_TO_PERSONA_MAP[PERSONA.AGENT];
                    if (!(agentPrivilege instanceof Array)){
                        agentPrivilege = [agentPrivilege];
                    }
                    var matchPrivileges = _.intersection(response[KEY.CONFIG][KEY.USER_PRIVILEGES], agentPrivilege);
                    if (matchPrivileges && matchPrivileges.length > 0) {
                        // Add the agent persona as a default persona
                        response[KEY.CONFIG][KEY.DEFAULT_PERSONA] = PERSONA.AGENT;

                        // Add the agent and customizer persona to the personas array
                        response[KEY.CONFIG][KEY.PERSONAS].push(PERSONA.AGENT);
                        response[KEY.CONFIG][KEY.PERSONAS].push(PERSONA.CUSTOMIZER);
                    }
                }

                // Set the persona for the login
                if (!_.isUndefined(persona) && _.contains(response[KEY.CONFIG][KEY.PERSONAS], persona)) {
                    response[KEY.PERSONA] = persona;
                } else {
                    response[KEY.PERSONA] = response[KEY.CONFIG][KEY.DEFAULT_PERSONA];
                }

                // Clean the OTK value
                this.unset(KEY.OTK, { silent:true });

                // Set the ID to indicate a successful authentication (and trigger an event which modules can listen to)
                response[KEY.ID] = "authenticated";
            }

            return response;
        },

        _parsePrivilegeObject: function(privilegeValue) {
            return {
                num: privilegeValue && privilegeValue.privilege || privilegeValue,
                condition: privilegeValue && privilegeValue.condition
            };
        },

        _compareUserPrivligesForPersona : function(privilegeValue, privilegeKey, response){

            if (!_.isArray(privilegeValue)){
                privilegeValue = [privilegeValue];
            }

            if (this.hasLiveEngage2 || PERSONA.ADMIN !== privilegeKey){

				_.each(privilegeValue, function(privValue){
                    var privValueObject = this._parsePrivilegeObject(privValue);
                    var privValueNum = privValueObject.num;
                    var privValueCondition = privValueObject.condition;
                    var checkPersona = !privValueCondition || privValueCondition && privValueCondition.method && this[privValueCondition.method] && this[privValueCondition.method].apply(this, privValueCondition.args);

                    if (checkPersona && _.contains(response[KEY.CONFIG][KEY.USER_PRIVILEGES], privValueNum)) {

                        // Check if this persona should be the default persona
						if (_.isUndefined(response[KEY.CONFIG][KEY.DEFAULT_PERSONA]) || DEFAULT_PERSONA_PRIORITY_MAP[privilegeKey] > DEFAULT_PERSONA_PRIORITY_MAP[response[KEY.CONFIG][KEY.DEFAULT_PERSONA]]) {
							// Add the persona as a default persona
							response[KEY.CONFIG][KEY.DEFAULT_PERSONA] = privilegeKey;
						}

						// Add the persona to the personas array based on priority
						if (response[KEY.CONFIG][KEY.PERSONAS].indexOf(privilegeKey) === -1){
							response[KEY.CONFIG][KEY.PERSONAS].splice(DEFAULT_PERSONA_PRIORITY_MAP[privilegeKey], 0, privilegeKey);
						}

					}

				}, this);
            }
        },

        save:function (creds, options) {
            options = options || {};

            var success = options.success;

            // Want to store the data upon success
            options.success = function () {
                this.store();

                if (success) {
                    success.apply(this, [].slice.apply(arguments));
                }
            }.bind(this);

            // First lets validate
            if (this.isNewSession(creds)) {
                var clearOptions = $.extend(true, { flushStore: { session: false, local: true }, silent: true }, creds);

                // First lets be sure there is no previous garbage (clear old data)
                this.clear(clearOptions);

                // We need to create the session using POST
                return BaseModel.prototype.save.call(this, creds, options);

            } else {
                // I just want to update the client data for the existing session
                // So I need to fetch (GET)
                // Since fetch does not validate the data (OTK||CSRF & ACCOUNT ID)
                // I'll trigger the validation
                var invalid = this.validate.call(this, creds);

                if (invalid) {
                    this.trigger("invalid", invalid);
                } else {
                    // Now lets get the data
                    return BaseModel.prototype.fetch.call(this, options);
                }
            }
        },

        sustain:function (creds, options) {
            options = options || {};

            var success = options.success;

            // Want to store the data upon success
            options.success = function () {
                this.updateLastTouched();

                if (success) {
                    success.apply(this, [].slice.apply(arguments));
                }
            }.bind(this);

            // First lets validate
            if (this.isNewSession(creds)) {
                // Needs to create the session first
                return this.save.call(this, creds, options);
            } else {
                // Lets refresh the session

                // So I need to fetch (GET)
                // Since fetch does not validate the data (OTK||CSRF & ACCOUNT ID)
                // I'll trigger the validation
                var invalid = this.validate.call(this, creds);

                if (invalid) {
                    this.trigger("invalid", invalid);
                } else {
                    // jQuery cannot parse empty strings and since the platform return no response from the refresh API,
                    // I'll need to treat the response as text instead of JSON
                    options.dataType = "text";
                    options.data = options.data || $.ajaxSettings.data || {};
                    options.data.refresh = true;

                    // Lets do the refresh
                    return BaseModel.prototype.fetch.call(this, options);
                }
            }
        },

        flushStore:function (options) {
            options = options || {};
            options.flushStore = options.flushStore || {};

            // For hacking multitab support
            // TODO: Remove when MultiTab support should be enabled
            if (!options.noDestroy) { //} && options.flushStore.local) {
                var accountId = options.accountId || this.get(KEY.ACCOUNT_ID);

                if (!this.isNullOrEmptyString(accountId)) {
                    this.localStorageClearItem(accountId + "_" + KEY.CSRF);
                    this.localStorageClearItem(accountId + "_" + KEY.PERSONA);
                    this.localStorageClearItem(accountId + "_" + KEY.LAST_TOUCH);
                    this.localStorageClearItem(accountId + "_" + KEY.INVALIDATED);

                    this.removeAccountIdFromCurrent(accountId);
                }
            }

            if (options.flushStore.session) {
                this.sessionStorageClearItem(KEY.USER_ID + "_LE2");
            }
        },

        clear:function (options) {
            this.flushStore(options);
            BaseModel.prototype.clear.call(this, options);
        },

        store:function (options) {
            options = options || {};

            var silentOption = { silent:true };
            var storeAccountIdOptions = silentOption;
            var accountId = options.accountId;

            if (this.isNullOrEmptyString(accountId)) {
                accountId = this.get(KEY.ACCOUNT_ID);
                storeAccountIdOptions = void 0;
            }
            if (this.isNullOrEmptyString(accountId)) {
                accountId = this.getCurrentAccountId();
                storeAccountIdOptions = silentOption;
            }

            if (!this.isNullOrEmptyString(accountId)) {
                var setCsrfOptions = silentOption;
                var setPersonaOptions = silentOption;
                var csrf = options.csrf;
                var persona = options.persona;

                if (this.isNullOrEmptyString(csrf)) {
                    csrf = this.get(KEY.CSRF);
                    setCsrfOptions = void 0;
                }

                if (this.isNullOrEmptyString(persona)) {
                    persona = this.get(KEY.PERSONA);
                    setPersonaOptions = void 0;
                }

                if (!this.isNullOrEmptyString(csrf)) {
                    this.storeValue({ key:KEY.CSRF, value:csrf, accountId:accountId, setValueOptions:setCsrfOptions });
                }

                if (!this.isNullOrEmptyString(persona)) {
                    this.storeValue({ key:KEY.PERSONA, value:persona, accountId:accountId, setValueOptions:setPersonaOptions });
                }

                this.storeValue({ key:KEY.ACCOUNT_ID, value:accountId, setValueOptions:storeAccountIdOptions });
                this.updateLastTouched();

                this.sessionStorageStoreItem(KEY.USER_ID + "_LE2", JSON.stringify(accountId + ">>" + this.get(KEY.CONFIG + "." + KEY.LOGIN_NAME)));
            }
        },

        destroy:function (options) {
            options = options || {};

            // jQuery cannot parse empty strings and since the platform return no response from the refresh API,
            // I'll need to treat the response as text instead of JSON
            options.dataType = "text";

            // Lets do the destroy
            return BaseModel.prototype.destroy.call(this, options);
        },

        expire:function (options) {
            // Set auth to false to trigger a change:auth event
            // The server also returns a new csrf token so that
            // the user can relogin without refreshing the page
            options = options || {};

            var hasAccount = !this.isNullOrEmptyString(options[KEY.ACCOUNT_ID]);
            var hasCsrf = !this.isNullOrEmptyString(options[KEY.CSRF]);
            var hasPersona = !this.isNullOrEmptyString(options[KEY.PERSONA]);

            var expiration = {};
            expiration[KEY.ID] = defaults[KEY.ID];
            expiration[KEY.OTK] = defaults[KEY.OTK];
            expiration[KEY.ACCOUNT_ID] = hasAccount ? options[KEY.ACCOUNT_ID] : defaults[KEY.ACCOUNT_ID];
            expiration[KEY.CONFIG] = defaults[KEY.CONFIG];
            expiration[KEY.WSUK] = defaults[KEY.WSUK];
            expiration[KEY.GLOB] = defaults[KEY.GLOB];
            expiration[KEY.CSRF] = hasCsrf ? options[KEY.CSRF] : defaults[KEY.CSRF];
            expiration[KEY.PERSONA] = hasPersona ? options[KEY.PERSONA] : defaults[KEY.PERSONA];
            expiration[KEY.PERSONAS] = defaults[KEY.PERSONAS];

            var accountId = hasAccount ? options[KEY.ACCOUNT_ID] : this.get(KEY.ACCOUNT_ID);

            this.set(expiration, { silent:!hasCsrf });
            this.clear($.extend(true, { flushStore: { session: false, local: true } }, options, { silent:hasCsrf, accountId:accountId }));
        },

        _findFeature:function (response, search_feature) {
            var provisionData = response[KEY.ACCOUNT_DATA][KEY.PROVISION_DATA];
            if (provisionData) {
                var features = provisionData[KEY.FEATURES];
                if (features) {
                    var feature = _.find(features, function (val) {
                        return val.compoundFeatureID === search_feature;
                    });
                    if (feature && feature.value) {
                        return feature.value.value;
                    }
                }
            }
            return false;
        },

        _findConfig:function(response, search_config) {
            var configData = response[KEY.CONFIG];
            if (configData) {
                return configData[search_config];
            }
            return false;
        },

        hasDataEncryptionDataFeature:function () {
            return this.hasDataEncryptionFeature;
        },

        hasAsyncMessagingFeature:function () {
            return this.hasMessagingFeature;
        },
        hasSLAPerSkillFeature:function () {
            return this.hasSLAPerSkill;
        },
        hasWrapUpTimeFeature:function () {
            return this.hasWrapUpFeature;
        },

        hasUserTypeBotFeature:function () {
            return this.hasUserTypeBot;
        },

        hasConversationSourcesFeature:function () {
            return this.hasAsyncMessagingFeature() && this.hasConversationSources;
        },

        hasMessagingAutoMessagesFeature:function () {
            return this.hasAsyncMessagingFeature() && this.hasMessagingAutoMessages;
        },

        hasUnauthMessagingFeature:function () {
            return this.hasAsyncMessagingFeature() && this.hasUnauthMessaging;
        },

        hasAutoClosePerSkillFeature: function () {
            return this.hasAsyncMessagingFeature() && this.hasAutoClosePerSkill;
        },

        hasEditMessagingAutoMessagesFeature:function () {
            return this.hasAsyncMessagingFeature() && this.hasEditMessagingAutoMessages;
        },

        hasMessagingTransferToAgentFeature: function () {
            return this.hasAsyncMessagingFeature() && this.hasMessagingTransferToAgent;
        },

        hasGoogleSourceFeature:function () {
            return this.hasConversationSourcesFeature() && this.hasGoogleSource;
        },

        hasLpAuthenticationSupportFeature:function() {
            return this.hasLpAuthenticationFeature;
        },

        hasLiveEngage2Feature:function () {
            return this.hasLiveEngage2;
        },

        hasMigratingFeature: function() {
            return this.isMigrating;
        },

        hasAgentGroupsFeature: function() {
            return this.isAgentGroups;
        },

        hasVisitorFeedPreFiltering: function() {
            return this.isVisitorFeedPreFiltering;
        },

        hasBlockAddingUsersFeature: function() {
            return this.isBlockAddingUsersFeature;
        },

        hasBlockSupportAccessFeature: function() {
            return this.isBlockSupportAccessFeature;
        },

        hasBlockMSTRAccessFeature: function() {
            return this.blockMSTR;
        },

        hasApiKeyManagementFeature: function() {
            return this.apiKeyManagement;
        },

        hasIpRestrictionFeature: function() {
            return this.ipRestriction;
        },

        hasLEMyAccount: function() {
            return this.enableLEMyAccount;
        },

        hasReportBuilderAccessFeature: function() {
            return this.reportBuilderAccessFeature;
        },

        hasReportBuilderNonLpaAccessFeature: function() {
            return this.reportBuilderNonLpaAccessFeature;
        },

        hasSeatBasedFeature: function(){
            return this.isSeatBasedFeature;
        },

        isUnifiedWindowEnabled: function() {
            return this.unifiedWindow;
        },

        hasLimitStickySizeFeature: function() {
            return this.limitStickySize;
        },
        hasHotTopicsFeature: function() {
            return this.hotTopicsFeature;
        },
        hasAuthenticationChatFeature: function () {
            return this.authenticationChat;
        },
        isLPA: function() {
            return this.lpa;
        },
        hasAIAssistWidgetFeature: function() {
            return this.aiAssistWidgetFeature;
        },
        isAdmin: function() {
            return this.admin;
        },
        hasMultiChatCenterLoadBalancing: function() {
            return this.multiChatCenterLoadBalancing;
        },
        hasCoBrowseFeature: function() {
            return this.hasCoBrowseFeauture;
        },
        hasMultiChatCenterCascadingLoadBalancing: function() {
            return this.multiChatCenterCascadingLoadBalancing;
        },
        hasLobFeature: function() {
            return this.lobFeature;
        },
        hasEntitiesTaggingByLobFeature: function() {
            return this.hasLobFeature() && this.entitiesTaggingByLob;
        },
        hasProfilesFeature: function() {
            return this.profilesFeature;
        },
        hasConnectionBarCaseManagementVisible: function(){
            return this.connectionBarCaseManagementVisible;
        },
        hasConnectionBarDisplay: function(){
            return this.connectionBarDisplay;
        },
        hasConnectionBarOpenCaseVisible: function(){
            return this.connectionBarOpenCaseVisible;
        },
        hasConnectionBarNotificationVisible: function(){
            return this.connectionBarNotificationVisible;
        },
        hasLpaProfilesAssignmentFeature: function(){
            return this.lpaProfilesAssignmentFeature;
        },
        hasAuditTrailFeature: function() {
            return this.auditTrailFeature;
        },
        hasMultipleAgentStatesFeature: function() {
            return this.multipleAgentStatesFeature;
        },
        hasRefreshButtonFeature: function() {
            return this.refreshButtonFeature;
        },
        hasLiveChatQueuePriorityFeature: function() {
            return this.liveChatQueuePriority;
        },
        hasAutomationAreaFeature: function() {
            return this.automationAreaFeature;
        },
        hasContentProviderAccountFeature: function(){
            return this.contentProviderAccountFeature;
        },
        hasMessagingSurveyFeature: function() {
            return this.messagingSurveyFeature;
        }
    });

    // Public ENUM to control
    // The key
    SessionModel.KEY = KEY;

    // Public ENUM to control
    // The persona
    SessionModel.PERSONA = PERSONA;

    // Public ENUM to control
    // account settings key
    SessionModel.ACCOUNT_SETTINGS_ID = ACCOUNT_SETTINGS_ID;
    SessionModel.COMPOUND_FEATURE_ID = COMPOUND_FEATURE_ID;
    SessionModel.CONFIG_ATTRIBUTE_ID = CONFIG_ATTRIBUTE_ID;
    // Public ENUM to control
    // The user privileges
    SessionModel.PRIVILEGE_TO_PERSONA_MAP = PRIVILEGE_TO_PERSONA_MAP;

    // Public ENUM to control
    // The user default personas priorities
    SessionModel.DEFAULT_PERSONA_PRIORITY_MAP = DEFAULT_PERSONA_PRIORITY_MAP;

    return new SessionModel();

});
